// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1-O7f","upload":"Small_upload__1XIrB","imageWrap":"Small_imageWrap__2mX-z","removeBtn":"Small_removeBtn__Lb7Xt"};